"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevenueOrganizationReconciliation = exports.RevenueSiteReconciliation = exports.RevenueChargerReconciliation = exports.RevenueChargerPortReconciliation = exports.EmspRevenueReconciliation = exports.BaseRevenueReconciliation = exports.RevenueMismatches = exports.RevenueNotMatch = exports.MAPITransactionResult = exports.CreditCardInformation = exports.TransactionSorting = exports.TransactionList = exports.TransactionDetails = exports.TransactionTrackingType = exports.EVCCIDStats = exports.OrganizationLoyaltyTransactionStats = exports.OrganizationTransactionStats = exports.TransactionStatsBreakdown = exports.ManufacturerStats = exports.TransactionStopReasonStats = exports.TransactionErrorCodeStats = exports.EquipmentManufacturer = void 0;
const ee_proto_interfaces_1 = require("ee-proto-interfaces");
const swagger_proxy_1 = require("./swagger-proxy");
const class_validator_proxy_1 = require("./class-validator-proxy");
const class_transformer_proxy_1 = require("./class-transformer-proxy");
const ocpi_1 = require("./ocpi");
var EquipmentManufacturer;
(function (EquipmentManufacturer) {
    EquipmentManufacturer["DELTA_ELECTRONICS"] = "Delta Electronics";
    EquipmentManufacturer["VOLKSWAGEN_GROUP_OF_AMERICA"] = "Volkswagen Group of America";
    EquipmentManufacturer["LG_INNOTEK"] = "LG Innotek";
    EquipmentManufacturer["TESTOP"] = "TESTOP";
    EquipmentManufacturer["DENSO"] = "Denso";
    EquipmentManufacturer["LEAR"] = "Lear";
    EquipmentManufacturer["RIVIAN"] = "Rivian";
    EquipmentManufacturer["CONTINENTAL"] = "Continental";
    EquipmentManufacturer["WE_CORPORATION"] = "We Corporation";
    EquipmentManufacturer["TESLA"] = "Tesla";
    EquipmentManufacturer["VISTEON"] = "Visteon";
    EquipmentManufacturer["LUCID"] = "Lucid Motors";
    EquipmentManufacturer["PORSCHE"] = "Porsche Cars North America";
    EquipmentManufacturer["BMW"] = "BMW AG";
    EquipmentManufacturer["POLESTAR"] = "Polestar Corp.";
    EquipmentManufacturer["FORD"] = "Ford Motor Company";
    EquipmentManufacturer["KOSTAL"] = "Leopold Kostal GmbH &Co. KG";
    EquipmentManufacturer["UNKNOWN"] = "Unknown";
})(EquipmentManufacturer = exports.EquipmentManufacturer || (exports.EquipmentManufacturer = {}));
/**
 * Stats for a given error code.
 */
class TransactionErrorCodeStats {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Error code identifier",
        example: "OVERVOLTAGE",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], TransactionErrorCodeStats.prototype, "errorCode", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total number of times this error was seen",
        example: 15,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionErrorCodeStats.prototype, "timesSeen", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Number of times this error was fatal (prevented charging)",
        example: 3,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionErrorCodeStats.prototype, "timesFatal", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Breakdown of error occurrences by vehicle manufacturer",
        type: [String, Number],
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    __metadata("design:type", Array)
], TransactionErrorCodeStats.prototype, "manufacturerBreakdown", void 0);
exports.TransactionErrorCodeStats = TransactionErrorCodeStats;
/**
 * Stats for a given stop reason.
 */
class TransactionStopReasonStats {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Stop reason identifier",
        example: "EV_DISCONNECTED",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], TransactionStopReasonStats.prototype, "stopReason", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Number of times this stop reason was encountered",
        example: 42,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionStopReasonStats.prototype, "timesSeen", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Breakdown of stop reason occurrences by vehicle manufacturer",
        type: [String, Number],
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    __metadata("design:type", Array)
], TransactionStopReasonStats.prototype, "manufacturerBreakdown", void 0);
exports.TransactionStopReasonStats = TransactionStopReasonStats;
/**
 * Stats broken out by manufacturer.
 */
class ManufacturerStats {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Vehicle equipment manufacturer",
        enum: EquipmentManufacturer,
        example: EquipmentManufacturer.TESLA,
    }),
    (0, class_validator_proxy_1.IsEnum)(EquipmentManufacturer),
    __metadata("design:type", String)
], ManufacturerStats.prototype, "manufacturer", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total number of transactions for this manufacturer",
        example: 250,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], ManufacturerStats.prototype, "totalTransactions", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Number of failed transactions for this manufacturer",
        example: 12,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], ManufacturerStats.prototype, "failedTransactions", void 0);
exports.ManufacturerStats = ManufacturerStats;
/**
 * Transaction statistics breakdown.
 */
class TransactionStatsBreakdown {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total number of charging sessions",
        example: 1250,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionStatsBreakdown.prototype, "totalSessions", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total number of successful charging sessions",
        example: 1180,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionStatsBreakdown.prototype, "totalSuccessfulSessions", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Start time of the statistics period",
        type: Date,
    }),
    (0, class_validator_proxy_1.IsDate)(),
    __metadata("design:type", Date)
], TransactionStatsBreakdown.prototype, "startTime", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "End time of the statistics period",
        type: Date,
    }),
    (0, class_validator_proxy_1.IsDate)(),
    __metadata("design:type", Date)
], TransactionStatsBreakdown.prototype, "endTime", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Average sessions per day",
        example: 15.2,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionStatsBreakdown.prototype, "sessionsPerDay", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Average successful sessions per day",
        example: 14.3,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionStatsBreakdown.prototype, "successfulSessionsPerDay", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Average energy delivered per session in kWh",
        example: 28.5,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionStatsBreakdown.prototype, "averageEnergyKwh", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Average peak power per session in kW",
        example: 45.2,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionStatsBreakdown.prototype, "averagePeakPowerKw", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Average session length in seconds",
        example: 3600,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionStatsBreakdown.prototype, "averageSessionLength", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total revenue generated",
        example: 125000,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionStatsBreakdown.prototype, "totalRevenue", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total energy delivered in kWh",
        example: 33650,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionStatsBreakdown.prototype, "totalEnergy", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Error code statistics breakdown",
        type: TransactionErrorCodeStats,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => TransactionErrorCodeStats),
    __metadata("design:type", Array)
], TransactionStatsBreakdown.prototype, "errorCodes", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Stop reason statistics breakdown",
        type: TransactionStopReasonStats,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => TransactionStopReasonStats),
    __metadata("design:type", Array)
], TransactionStatsBreakdown.prototype, "stopReasons", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Vehicle manufacturer statistics breakdown",
        type: ManufacturerStats,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => ManufacturerStats),
    __metadata("design:type", Array)
], TransactionStatsBreakdown.prototype, "manufacturerStats", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total card present payment transactions",
        example: 800,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionStatsBreakdown.prototype, "totalPaymentCardPresent", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total offline card present payment transactions",
        example: 50,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionStatsBreakdown.prototype, "totalPaymentCardPresentOffline", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total phone-based card present payment transactions",
        example: 200,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionStatsBreakdown.prototype, "totalPaymentCardPresentPhone", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total command console payment transactions",
        example: 80,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionStatsBreakdown.prototype, "totalPaymentCommandConsole", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total free sessions initiated by NOC",
        example: 120,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionStatsBreakdown.prototype, "totalFreeSessionsFromNoc", void 0);
exports.TransactionStatsBreakdown = TransactionStatsBreakdown;
/**
 * Organization level statistics aggregating transaction data.
 */
class OrganizationTransactionStats {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Aggregate statistics summary for the organization",
        type: TransactionStatsBreakdown,
    }),
    (0, class_validator_proxy_1.ValidateNested)(),
    (0, class_transformer_proxy_1.Type)(() => TransactionStatsBreakdown),
    __metadata("design:type", TransactionStatsBreakdown)
], OrganizationTransactionStats.prototype, "aggregateStats", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Daily session counts for each day in the period",
        type: Number,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.IsNumber)({}, { each: true }),
    __metadata("design:type", Array)
], OrganizationTransactionStats.prototype, "dailySessions", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Daily successful session counts for each day in the period",
        type: Number,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.IsNumber)({}, { each: true }),
    __metadata("design:type", Array)
], OrganizationTransactionStats.prototype, "dailySuccessfulSessions", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Daily average energy delivered per session (kWh)",
        type: Number,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.IsNumber)({}, { each: true }),
    __metadata("design:type", Array)
], OrganizationTransactionStats.prototype, "dailyAverageEnergyKwh", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Daily average peak power per session (kW)",
        type: Number,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.IsNumber)({}, { each: true }),
    __metadata("design:type", Array)
], OrganizationTransactionStats.prototype, "dailyAveragePeakPowerKw", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Daily average session length in seconds",
        type: Number,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.IsNumber)({}, { each: true }),
    __metadata("design:type", Array)
], OrganizationTransactionStats.prototype, "dailyAverageSessionLength", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Daily error code occurrence counts",
        type: [[[String]]],
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    __metadata("design:type", Array)
], OrganizationTransactionStats.prototype, "dailyErrorCodeCount", void 0);
exports.OrganizationTransactionStats = OrganizationTransactionStats;
/**
 * Organization level loyalty statistics.
 */
class OrganizationLoyaltyTransactionStats {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Top 10 customers by transaction count",
        type: Object,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => EVCCIDStats),
    __metadata("design:type", Array)
], OrganizationLoyaltyTransactionStats.prototype, "top10EvccIds", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total number of charging sessions",
        example: 2450,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], OrganizationLoyaltyTransactionStats.prototype, "totalSessions", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total sessions by customers with multiple visits",
        example: 1800,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], OrganizationLoyaltyTransactionStats.prototype, "totalSessionsByRepeatCustomers", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total number of unique customers",
        example: 450,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], OrganizationLoyaltyTransactionStats.prototype, "numberOfuniqueCustomers", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Number of customers with repeat visits",
        example: 280,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], OrganizationLoyaltyTransactionStats.prototype, "numberOfRepeatCustomers", void 0);
exports.OrganizationLoyaltyTransactionStats = OrganizationLoyaltyTransactionStats;
/**
 * EVCCID statistics of customers
 */
class EVCCIDStats {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Electric Vehicle Contract ID",
        example: "ABC123DEF456789",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], EVCCIDStats.prototype, "evccid", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "List of transaction details for this customer",
        type: Object,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    __metadata("design:type", Array)
], EVCCIDStats.prototype, "transaction", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total number of transactions for this customer",
        example: 25,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], EVCCIDStats.prototype, "count", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total amount spent by this customer",
        example: 485.5,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], EVCCIDStats.prototype, "totalAmountSpent", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total energy consumed by this customer in kWh",
        example: 750.25,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], EVCCIDStats.prototype, "totalConsumedEnergyKwh", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Details of the customer's most recent transaction",
        type: Object,
    }),
    (0, class_validator_proxy_1.IsObject)(),
    __metadata("design:type", Object)
], EVCCIDStats.prototype, "latestTransaction", void 0);
exports.EVCCIDStats = EVCCIDStats;
/**
 * List of transaction tracking types
 */
var TransactionTrackingType;
(function (TransactionTrackingType) {
    TransactionTrackingType["ATYPICAL_TESTING"] = "Atypical Testing";
    TransactionTrackingType["COMMISSIONING"] = "Commissioning";
    TransactionTrackingType["MAINTENANCE_WINDOW"] = "Maintenance Window";
    TransactionTrackingType["FREE_PRICING_MAINTENANCE_WINDOW"] = "Free Price Maintenance Window";
})(TransactionTrackingType = exports.TransactionTrackingType || (exports.TransactionTrackingType = {}));
/**
 * A charging session containing basic data about the session.
 */
class TransactionDetails {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Unique transaction identifier",
        example: "txn_123456789",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], TransactionDetails.prototype, "transactionId", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Session start timestamp",
        example: "2024-01-15T10:30:00Z",
        type: Date,
    }),
    (0, class_validator_proxy_1.IsDate)(),
    __metadata("design:type", Date)
], TransactionDetails.prototype, "sessionStart", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Session start timestamp in the station's local timezone",
        example: "09/03/25, 05:55 PM PDT",
        type: String,
    }),
    (0, class_validator_proxy_1.IsDate)(),
    __metadata("design:type", String)
], TransactionDetails.prototype, "sessionStartLocalTime", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Session end timestamp",
        example: "2024-01-15T11:45:00Z",
        type: Date,
    }),
    (0, class_validator_proxy_1.IsDate)(),
    __metadata("design:type", Date)
], TransactionDetails.prototype, "sessionEnd", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Session end timestamp in the station's local timezone",
        example: "09/03/25, 05:55 PM PDT",
        type: String,
    }),
    (0, class_validator_proxy_1.IsDate)(),
    __metadata("design:type", String)
], TransactionDetails.prototype, "sessionEndLocalTime", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Transaction amount multiplied by precision factor",
        example: 1250,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionDetails.prototype, "transactionAmount", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Decimal precision factor for transaction amount",
        example: 100,
        type: Number,
        minimum: 1,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionDetails.prototype, "transactionAmountPrecision", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "OCPP identifier for the charger",
        example: "CHARGER_001",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], TransactionDetails.prototype, "chargerOcppId", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Serial number of the charger",
        example: "CHARGER_001",
        type: String,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], TransactionDetails.prototype, "chargerSerialNumber", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Human-readable charger identifier",
        example: "Main St Charger #1",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], TransactionDetails.prototype, "chargerFriendlyId", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Energy delivered during the session in kWh",
        example: 25.75,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionDetails.prototype, "energyDeliveredKwh", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Peak power during the session in kW",
        example: 50.0,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionDetails.prototype, "peakPowerKw", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total time during the session when charging was power limited, in milliseconds",
        example: 120000,
        type: Number,
        minimum: 0,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionDetails.prototype, "timePowerLimitedMs", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Fault code if session ended with error",
        example: "OVERVOLTAGE",
        type: String,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], TransactionDetails.prototype, "faultCode", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Finish code reported by the charger firmware at the end of a session",
        example: 42,
        type: Number,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionDetails.prototype, "finishCode", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Power quality issues that caused derating during this session.",
        isArray: true,
        type: Number,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    __metadata("design:type", Array)
], TransactionDetails.prototype, "powerQualityIssues", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Reason why the session stopped",
        example: "EV_DISCONNECTED",
        type: String,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], TransactionDetails.prototype, "stopReason", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Whether the transaction completed successfully",
        example: true,
        type: Boolean,
    }),
    (0, class_validator_proxy_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], TransactionDetails.prototype, "successful", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Unique reference for the transaction",
        example: "REF_ABC123DEF456",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], TransactionDetails.prototype, "uniqueReference", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Final totalizer reading",
        example: 12500,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionDetails.prototype, "totalizerEnd", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Port identifier on the charger",
        example: 1,
        type: Number,
        minimum: 1,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionDetails.prototype, "portId", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Electric Vehicle Communication Controller ID",
        example: "EVCC_789123",
        type: String,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], TransactionDetails.prototype, "evccid", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Type of charging port",
        enum: ee_proto_interfaces_1.charger.PortType,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsEnum)(ee_proto_interfaces_1.charger.PortType),
    __metadata("design:type", Number)
], TransactionDetails.prototype, "portType", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Detailed charging information",
        type: Object,
        isArray: true,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsArray)(),
    __metadata("design:type", Array)
], TransactionDetails.prototype, "details", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Low rate charging details",
        type: Object,
        isArray: true,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsArray)(),
    __metadata("design:type", Array)
], TransactionDetails.prototype, "lowRateDetails", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Related transactions by payment method",
        type: Object,
        isArray: true,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsArray)(),
    __metadata("design:type", Array)
], TransactionDetails.prototype, "relatedTransactionsByPayment", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Related transactions by EVCC ID",
        type: Object,
        isArray: true,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsArray)(),
    __metadata("design:type", Array)
], TransactionDetails.prototype, "relatedTransactionsByEVCCID", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Breakdown of charges and fees",
        type: Object,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsObject)(),
    __metadata("design:type", Object)
], TransactionDetails.prototype, "chargeBreakdown", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Type of payment authorization used",
        enum: ee_proto_interfaces_1.money.PaymentAuthorizationType,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsEnum)(ee_proto_interfaces_1.money.PaymentAuthorizationType),
    __metadata("design:type", Number)
], TransactionDetails.prototype, "authorizationType", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Status of payment authorization",
        enum: ee_proto_interfaces_1.money.PaymentAuthorizationStatus,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsEnum)(ee_proto_interfaces_1.money.PaymentAuthorizationStatus),
    __metadata("design:type", Number)
], TransactionDetails.prototype, "authorizationStatus", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Site identifier where transaction occurred",
        example: 42,
        type: Number,
        minimum: 1,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionDetails.prototype, "siteId", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Name of the organization",
        example: "Acme Corp",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], TransactionDetails.prototype, "organizationName", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Name of the site",
        example: "Downtown Location",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], TransactionDetails.prototype, "siteName", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Type of transaction tracking",
        enum: TransactionTrackingType,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsEnum)(TransactionTrackingType),
    __metadata("design:type", Object)
], TransactionDetails.prototype, "trackingType", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "The reason (if any) a transaction was free",
        type: Object,
    }),
    (0, class_validator_proxy_1.IsObject)(),
    __metadata("design:type", Number)
], TransactionDetails.prototype, "freeReason", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "If an emsp based transaction then the integration that it comes from",
        enum: ocpi_1.Integrations,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsEnum)(ocpi_1.Integrations),
    __metadata("design:type", Object)
], TransactionDetails.prototype, "emspName", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "PowerNode ID for this transaction",
        example: 123,
        type: Number,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionDetails.prototype, "powernodeId", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Charger model identifier",
        example: "EEv3",
        type: String,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], TransactionDetails.prototype, "chargerModel", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Plug-in timestamp",
        type: Date,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsDate)(),
    __metadata("design:type", Date)
], TransactionDetails.prototype, "plugInUtc", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Unplug timestamp",
        type: Date,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsDate)(),
    __metadata("design:type", Date)
], TransactionDetails.prototype, "unplugUtc", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Active energy transfer start timestamp",
        type: Date,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsDate)(),
    __metadata("design:type", Date)
], TransactionDetails.prototype, "chargingStartUtc", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Active energy transfer end timestamp",
        type: Date,
        required: false,
    }),
    (0, class_validator_proxy_1.IsOptional)(),
    (0, class_validator_proxy_1.IsDate)(),
    __metadata("design:type", Date)
], TransactionDetails.prototype, "chargingEndUtc", void 0);
exports.TransactionDetails = TransactionDetails;
/**
 * A list of transactions.
 */
class TransactionList {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Array of transaction details",
        type: TransactionDetails,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => TransactionDetails),
    __metadata("design:type", Array)
], TransactionList.prototype, "transactions", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total number of pages available",
        example: 5,
        type: Number,
        minimum: 1,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], TransactionList.prototype, "pages", void 0);
exports.TransactionList = TransactionList;
/**
 * Desired sorting for transaction list.
 */
var TransactionSorting;
(function (TransactionSorting) {
    TransactionSorting["ENERGY_DELIVERED"] = "ENERGY_DELIVERED";
    TransactionSorting["PEAK_POWER"] = "PEAK_POWER";
    TransactionSorting["SESSION_START"] = "SESSION_START";
    TransactionSorting["SESSION_END"] = "SESSION_END";
    TransactionSorting["TRANSACTION_AMOUNT"] = "TRANSACTION_AMOUNT";
    TransactionSorting["CHARGER_ID"] = "CHARGER_ID";
})(TransactionSorting = exports.TransactionSorting || (exports.TransactionSorting = {}));
/**
 * Information about a credit card.
 */
class CreditCardInformation {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Name of the card holder",
        example: "John Smith",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], CreditCardInformation.prototype, "customerName", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Type of credit card",
        example: "Visa",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], CreditCardInformation.prototype, "cardType", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Masked primary account number",
        example: "****-****-****-1234",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], CreditCardInformation.prototype, "maskedPan", void 0);
exports.CreditCardInformation = CreditCardInformation;
/**
 * A transaction from the Worldnet merchant API.
 */
class MAPITransactionResult {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Unique reference identifier for the transaction",
        example: "REF_ABC123DEF456",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], MAPITransactionResult.prototype, "uniqueReference", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Terminal identifier",
        example: "TERM_001",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], MAPITransactionResult.prototype, "terminal", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Operator identifier",
        example: "OP_MAIN",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], MAPITransactionResult.prototype, "operator", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Order identifier",
        example: "ORDER_789123",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], MAPITransactionResult.prototype, "orderId", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Transaction date and time",
        example: "2024-01-15T10:30:00Z",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], MAPITransactionResult.prototype, "dateTime", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Transaction description",
        example: "EV Charging Payment",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], MAPITransactionResult.prototype, "description", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Customer name",
        example: "John Smith",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], MAPITransactionResult.prototype, "customerName", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Credit card type",
        example: "Visa",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], MAPITransactionResult.prototype, "cardType", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Masked primary account number",
        example: "****-****-****-1234",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], MAPITransactionResult.prototype, "maskedPan", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Transaction type",
        enum: ["VOID", "PAYMENT", "SALE", "PREAUTH", "COMPLETION", "REFUND"],
        example: "SALE",
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], MAPITransactionResult.prototype, "type", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "EBT transaction type",
        example: "NONE",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], MAPITransactionResult.prototype, "ebtType", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Result code from payment processor",
        example: "00",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], MAPITransactionResult.prototype, "resultCode", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Transaction status",
        enum: ["VOID", "COMPLETE", "READY", "PENDING"],
        example: "COMPLETE",
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], MAPITransactionResult.prototype, "status", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Currency code",
        example: "USD",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], MAPITransactionResult.prototype, "currency", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Transaction amount in cents",
        example: 2500,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], MAPITransactionResult.prototype, "amount", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Tip amount in cents",
        example: 0,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], MAPITransactionResult.prototype, "tipAmount", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Tax amount in cents",
        example: 200,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], MAPITransactionResult.prototype, "taxAmount", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Cashback amount in cents",
        example: 0,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], MAPITransactionResult.prototype, "cashbackAmount", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Surcharge amount in cents",
        example: 0,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], MAPITransactionResult.prototype, "surchargeAmount", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Dual pricing amount in cents",
        example: 0,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], MAPITransactionResult.prototype, "dualPricingAmount", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Convenience fee amount in cents",
        example: 0,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], MAPITransactionResult.prototype, "convenienceFeeAmount", void 0);
exports.MAPITransactionResult = MAPITransactionResult;
class RevenueNotMatch {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Revenue amount from EE system",
        example: 1250,
        type: Number,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], RevenueNotMatch.prototype, "eeAmount", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Revenue amount from MAPI system",
        example: 1275,
        type: Number,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], RevenueNotMatch.prototype, "mapiAmount", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Transaction details from EE system",
        type: TransactionDetails,
    }),
    (0, class_validator_proxy_1.ValidateNested)(),
    (0, class_transformer_proxy_1.Type)(() => TransactionDetails),
    __metadata("design:type", TransactionDetails)
], RevenueNotMatch.prototype, "eeTransaction", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Transaction details from MAPI system",
        type: Object,
    }),
    (0, class_validator_proxy_1.ValidateNested)(),
    (0, class_transformer_proxy_1.Type)(() => MAPITransactionResult),
    __metadata("design:type", MAPITransactionResult)
], RevenueNotMatch.prototype, "mapiTransaction", void 0);
exports.RevenueNotMatch = RevenueNotMatch;
class RevenueMismatches {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Transactions with revenue value mismatches",
        type: Object,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => RevenueNotMatch),
    __metadata("design:type", Array)
], RevenueMismatches.prototype, "revenueValueMismatches", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Failed transactions that still delivered energy",
        type: TransactionDetails,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => TransactionDetails),
    __metadata("design:type", Array)
], RevenueMismatches.prototype, "failedTransactionsWithEnergy", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Transactions that only exist in EE system",
        type: TransactionDetails,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => TransactionDetails),
    __metadata("design:type", Array)
], RevenueMismatches.prototype, "onlyExistsInEE", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Transactions that only exist in MAPI system",
        type: Object,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => MAPITransactionResult),
    __metadata("design:type", Array)
], RevenueMismatches.prototype, "onlyExistsInMAPI", void 0);
exports.RevenueMismatches = RevenueMismatches;
class BaseRevenueReconciliation {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total kWh dispensed from Chargers",
        example: 1234.125,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], BaseRevenueReconciliation.prototype, "totalKwhDispensed", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Total kWh accounted for via transactions",
        example: 1234.125,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], BaseRevenueReconciliation.prototype, "totalKwhAccountedFor", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Transaction amount multiplied by precision factor",
        example: 1250,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], BaseRevenueReconciliation.prototype, "totalTransactionAmount", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Decimal precision factor for transaction amount",
        example: 2,
        type: Number,
        minimum: 1,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], BaseRevenueReconciliation.prototype, "totalTransactionAmountPrecision", void 0);
exports.BaseRevenueReconciliation = BaseRevenueReconciliation;
class EmspRevenueReconciliation {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "An EMSP breakdown, undefined means it's for a standard payment.",
        example: "Wex",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], EmspRevenueReconciliation.prototype, "emspName", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "The percentage taken for this emsp.",
        example: "0.07",
        type: Number,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], EmspRevenueReconciliation.prototype, "emspPercentageRatioReduction", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Transaction amount multiplied by precision factor",
        example: 1250,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], EmspRevenueReconciliation.prototype, "totalTransactionAmount", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Decimal precision factor for transaction amount",
        example: 2,
        type: Number,
        minimum: 1,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], EmspRevenueReconciliation.prototype, "totalTransactionAmountPrecision", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Reconciled amount multiplied by precision factor",
        example: 1250,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], EmspRevenueReconciliation.prototype, "totalReconciledAmount", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Decimal precision factor for reconciled amount",
        example: 2,
        type: Number,
        minimum: 1,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], EmspRevenueReconciliation.prototype, "totalReconciledAmountPrecision", void 0);
exports.EmspRevenueReconciliation = EmspRevenueReconciliation;
class RevenueChargerPortReconciliation extends BaseRevenueReconciliation {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "OCPP identifier for the charger",
        example: "CHARGER_001",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], RevenueChargerPortReconciliation.prototype, "chargerOcppId", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Port identifier on the charger",
        example: 1,
        type: Number,
        minimum: 1,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], RevenueChargerPortReconciliation.prototype, "portId", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Emsp breakdown for reconciliation revenue include the non-emsp values as well.",
        enum: ocpi_1.Integrations,
        properties: {
            ...Object.fromEntries(Object.values(ocpi_1.Integrations).map((i) => [i, EmspRevenueReconciliation])),
            standard: EmspRevenueReconciliation,
        },
        type: Object,
    }),
    (0, class_validator_proxy_1.IsObject)(),
    __metadata("design:type", Object)
], RevenueChargerPortReconciliation.prototype, "emspBreakdown", void 0);
exports.RevenueChargerPortReconciliation = RevenueChargerPortReconciliation;
class RevenueChargerReconciliation extends BaseRevenueReconciliation {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "OCPP identifier for the charger",
        example: "CHARGER_001",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], RevenueChargerReconciliation.prototype, "chargerOcppId", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Serial number of the charger",
        example: "CHARGER_001",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], RevenueChargerReconciliation.prototype, "chargerSerialNumber", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Breakdown of charger ports data",
        type: Object,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => RevenueChargerPortReconciliation),
    __metadata("design:type", Array)
], RevenueChargerReconciliation.prototype, "chargerPorts", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Emsp breakdown for reconciliation revenue include the non-emsp values as well.",
        enum: ocpi_1.Integrations,
        properties: {
            ...Object.fromEntries(Object.values(ocpi_1.Integrations).map((i) => [i, EmspRevenueReconciliation])),
            standard: EmspRevenueReconciliation,
        },
        type: Object,
    }),
    (0, class_validator_proxy_1.IsObject)(),
    __metadata("design:type", Object)
], RevenueChargerReconciliation.prototype, "emspBreakdown", void 0);
exports.RevenueChargerReconciliation = RevenueChargerReconciliation;
class RevenueSiteReconciliation extends BaseRevenueReconciliation {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Site identifier for reconciliation",
        example: 42,
        type: Number,
        minimum: 1,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], RevenueSiteReconciliation.prototype, "siteId", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Name of the site",
        example: "Downtown Location",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], RevenueSiteReconciliation.prototype, "siteName", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Breakdown for each charger's data",
        type: Object,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => RevenueChargerReconciliation),
    __metadata("design:type", Array)
], RevenueSiteReconciliation.prototype, "chargers", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Emsp breakdown for reconciliation revenue include the non-emsp values as well.",
        enum: ocpi_1.Integrations,
        properties: {
            ...Object.fromEntries(Object.values(ocpi_1.Integrations).map((i) => [i, EmspRevenueReconciliation])),
            standard: EmspRevenueReconciliation,
        },
        type: Object,
    }),
    (0, class_validator_proxy_1.IsObject)(),
    __metadata("design:type", Object)
], RevenueSiteReconciliation.prototype, "emspBreakdown", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Amount to reconcile for this site.",
        example: 1250,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], RevenueSiteReconciliation.prototype, "totalReconciliationAmount", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Decimal precision factor for reconciliation amount.",
        example: 2,
        type: Number,
        minimum: 1,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], RevenueSiteReconciliation.prototype, "totalReconciliationAmountPrecision", void 0);
exports.RevenueSiteReconciliation = RevenueSiteReconciliation;
class RevenueOrganizationReconciliation {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Organization identifier for reconciliation",
        example: 42,
        type: Number,
        minimum: 1,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], RevenueOrganizationReconciliation.prototype, "organizationId", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Name of the organization",
        example: "Acme Corp",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], RevenueOrganizationReconciliation.prototype, "organizationName", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Breakdown for each site's data",
        type: Object,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.ValidateNested)({ each: true }),
    (0, class_transformer_proxy_1.Type)(() => RevenueSiteReconciliation),
    __metadata("design:type", Array)
], RevenueOrganizationReconciliation.prototype, "sites", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Emsp breakdown for reconciliation revenue include the non-emsp values as well.",
        enum: ocpi_1.Integrations,
        properties: {
            ...Object.fromEntries(Object.values(ocpi_1.Integrations).map((i) => [i, EmspRevenueReconciliation])),
            standard: EmspRevenueReconciliation,
        },
        type: Object,
    }),
    (0, class_validator_proxy_1.IsObject)(),
    __metadata("design:type", Object)
], RevenueOrganizationReconciliation.prototype, "emspBreakdown", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Amount to reconcile for this site.",
        example: 1250,
        type: Number,
        minimum: 0,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], RevenueOrganizationReconciliation.prototype, "totalReconciliationAmount", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Decimal precision factor for reconciliation amount.",
        example: 2,
        type: Number,
        minimum: 1,
    }),
    (0, class_validator_proxy_1.IsNumber)(),
    __metadata("design:type", Number)
], RevenueOrganizationReconciliation.prototype, "totalReconciliationAmountPrecision", void 0);
exports.RevenueOrganizationReconciliation = RevenueOrganizationReconciliation;
